import classNames from 'classnames';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { withLayoutContext } from '@bingads-webui-react/app-layout-container';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { Link as RouterLink } from '@bingads-webui-react/router';
import {
  withCampaignSiteMap,
  siteMapPropType,
  ScopeV2,
} from '@bingads-webui-react/with-site-map';

import { withLastURL } from '@bingads-webui-react/with-last-url';
import { getBackToCampaignItemStyles } from './back-to-campaign-item-styles';

const BackToCampaignItem = ({
  siteMap, classes, i18n, activity, scope, backButtonPath, backButtonUrl,
}) => {
  const selectedParent = _.findWhere(siteMap, { selected: true });
  const onClick = useCallback(() => (
    backButtonUrl ? null : () => {
      activity.signal('Back to campaign button clicked');
      const pathname = backButtonPath ? `${backButtonPath.routePrefix}${backButtonPath.route}` : backButtonPath;
      const search = `?${scope.stringify(ScopeV2.trimToScope(ScopeV2.Account, scope.values))}`;
      scope.history.push({
        pathname: pathname || '/campaign/vnext/campaigns',
        search,
      });
    }
  ), [activity, backButtonPath, backButtonUrl, scope]);

  const IconComponent = (<Glyphicon
    id="button-icon"
    className={classes.buttonIcon}
    glyph="ba-Back"
  />);

  const className = classNames(classes.backToCampaignButton, 'back-button', 'btn');

  if (selectedParent || !scope.values.aid) {
    return null;
  }

  return (
    <div className={classNames(classes.backToCampaignItemContainer, 'back-to-campaign-button-container')}>
      <OverlayTrigger
        key="back-button-tooltip"
        placement="right"
        delayShow={300}
        overlay={
          <Tooltip id="tooltip-right">
            {i18n.getString(_TL_('Back to Campaigns'))}
          </Tooltip>
          }
      >
        {
          backButtonUrl && backButtonUrl.startsWith('/campaign/vnext') ?
            <RouterLink
              to={backButtonUrl}
              className={className}
              onClick={onClick}
              aria-label={i18n.getString(_TL_('Back to Campaigns'))}
            >
              {IconComponent}
            </RouterLink>
         :
            <a
              href={backButtonUrl}
              className={className}
              onClick={onClick}
              aria-label={i18n.getString(_TL_('Back to Campaigns'))}
            >
              {IconComponent}
            </a>
        }
      </OverlayTrigger>
    </div>
  );
};

BackToCampaignItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getBackToCampaignItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  siteMap: siteMapPropType.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }),
  backButtonPath: PropTypes.string,
  backButtonUrl: PropTypes.string,
};

BackToCampaignItem.defaultProps = {
  activity: {
    signal: _.noop,
  },
  backButtonPath: '',
  backButtonUrl: '',
};

export default
withScope(withLastURL(withCampaignSiteMap(withLayoutContext(withActivityContext(withDefaultStyles(
  BackToCampaignItem,
  getBackToCampaignItemStyles
))))));
